import { CurrencyPipe, DecimalPipe, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';

@Component({
	selector: 'deduction-grading-table',
	template: ` <div class="col-xs-5">
		<span class="standaloneText">{{ to.label }} Deduction Grading Table</span>
		<table class="table noBottomMargin" *ngIf="to.deductionGrade">
			<thead>
				<tr>
					<th class="alignRight">Min.YTD Earnings</th>
					<th class="alignRight">Amount</th>
					<th class="alignRight">Percentage</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td class="alignRight">
						{{ to.deductionGrade.MinimumEarnings | currency }}
					</td>
					<td class="alignRight">
						<span *ngIf="!to.deductionGrade.Percentage || to.deductionGrade.Percentage === 0">
							{{ to.deductionGrade.Amount | currency }}
						</span>
						<span *ngIf="to.deductionGrade.Percentage && to.deductionGrade.Percentage !== 0"> -- </span>
					</td>
					<td class="alignRight">
						<span *ngIf="!to.deductionGrade.Amount || to.deductionGrade.Amount === 0">
							{{ to.deductionGrade.Percentage | number }}%
						</span>
						<span *ngIf="to.deductionGrade.Amount && to.deductionGrade.Amount !== 0"> -- </span>
					</td>
				</tr>
			</tbody>
		</table>
	</div>`,
	standalone: true,
	imports: [NgIf, DecimalPipe, CurrencyPipe],
})
export class DeductionGradingTableComponent extends FieldType<FormlyFieldConfig> {}
